import React from "react";
import { LinkProps } from "react-router-dom";

import { Grid, Typography, Skeleton, Box } from "@mui/material";
import { ButtonLink } from "../MUIExtensions/ButtonLink";

import { SxProps } from "@mui/system";
import { Edit } from "@mui/icons-material";

const outerStyles: SxProps = {
  backgroundColor: "common.white",
  border: 1,
  borderColor: "primary.light",
  borderRadius: "12px",
  flex: 1,
  padding: 1,
};

export const InfoCard = ({
  title,
  value,
  loading = false,
  captionColor,
  hasEdit,
}: InfoCardProps) => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="space-between"
      sx={outerStyles}
      rowGap={1}
    >
      <Grid container direction="row" alignItems="center">
        <Typography variant="body2" color="primary.main" component="span">
          {title}
        </Typography>
        {captionColor && (
          <Box
            sx={{
              marginLeft: 0.5,
              height: 3,
              width: 40,
              bgcolor: captionColor,
            }}
          />
        )}
      </Grid>

      <Grid container justifyContent="space-between" wrap="nowrap">
        <Typography variant="caption" width="100%">
          {loading ? <Skeleton /> : value}
        </Typography>
        {hasEdit && !loading && (
          <ButtonLink
            sx={{ padding: 0, minWidth: 0 }}
            to={{
              pathname: hasEdit.link.toString(),
              state: hasEdit.value,
            }}
          >
            <Edit />
          </ButtonLink>
        )}
      </Grid>
    </Grid>
  );
};

export type InfoCardProps = {
  title: string;
  value: string;
  /** If true, will render skeleton instead of value */
  loading?: boolean;
  /** Hex of the color the line should be */
  captionColor?: string;
  hasEdit?: {
    value: string;
    link: LinkProps["to"];
  };
  /** If provided, will receive a value and the link to be redirected*/
};
